<template>
  <div>
    <!-- Toast de alerta -->
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
      @close="closeToast"
    />
    <div class="flex max-w-[1440px] mx-auto h-full font-poppins bg-white">
      <!-- Panel izquierdo -->
      <div class="w-full sm:w-1/2 flex flex-col bg-white min-h-screen">
        <!-- Encabezado -->
        <HeaderComponent class="md:mb-6 mb-4" />

        <!-- Contenido -->
        <div class="mb-4 mx-auto px-5 md:p-0 md:ml-[80px] md:mx-0 w-11/12 md:w-3/4 max-w-[384px] bg-white">
          
          <!-- Barra de progreso -->
          <div class="flex justify-between mb-0">
            <span></span>
            <span class="text-sm font-medium text-custom_gray">{{ currentStep + 1 }}/4</span>
          </div>
          <div class="md:mb-6 mb-3 w-full bg-[#D9D9D9] rounded-full h-2.5">
            <div class="bg-tuin-100 h-2.5 rounded-full" :style="{ width: progressPercentage + '%' }"></div>
          </div>

          <!-- Formulario -->
          <form @submit.prevent="RegisterAccount" novalidate>
            <div class="md:space-y-6 space-y-4">
              <h5 class="lg:text-32 text-lg font-medium text-custom_black">Registro</h5>

              <!-- Email -->
              <div>
                <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Correo*</label>
                <input
                  type="text"
                  v-model="email"
                  id="email"
                  :class="{
                    'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.email,
                    'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.email
                  }"
                  placeholder="Ingresa tu correo"
                  @blur="validateEmail"
                />
                <p v-if="errors.email" class="mt-1 text-sm font-medium text-red-600">{{ errors.email }}</p>
              </div>

              <!-- Contraseña -->
              <div>
                <ValidatedPasswordInput
                  v-model="password"
                  id="password"
                  name="password"
                  label="Contraseña*"
                  placeholder="Ingresa tu contraseña"
                  :error="errors.password"
                  @blur="validatePassword"
                />
                <p v-if="errors.password" class="mt-1 text-sm font-medium text-red-600">{{ errors.password }}</p>
              </div>

              <!-- Confirmar contraseña -->
              <div>
                <PasswordInputComponent
                  v-model="password_confirmation"
                  id="confirm-password"
                  name="confirm-password"
                  label="Confirmar Contraseña*"
                  placeholder="Confirma tu contraseña"
                  :error="errors.password_confirmation"
                  @blur="validatePasswordConfirmation"
                />
                <p v-if="errors.password_confirmation" class="mt-1 text-sm font-medium text-red-600">{{ errors.password_confirmation }}</p>
              </div>

              <!-- Términos y condiciones -->
              <div class="flex items-center">
                <input
                  id="terms"
                  type="checkbox"
                  v-model="terms"
                  class="w-4 h-4 border border-gray-300 rounded bg-gray-50 text-tuin_base-0 focus:ring-transparent"
                  
                />
                <a
                  :href="termsLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="ms-2 text-[12px] font-medium text-tuin_base-0 not-italic hover:underline"
                >
                  Aceptar Términos y Condiciones
                </a>
              </div>

              <!-- Botón de crear cuenta -->
              <div>
                <button
                  type="submit"
                  class="w-full bg-tuin-100 text-white font-semibold py-2.5 px-4 rounded-lg hover:bg-tuin_hover transition disabled:bg-tuin-100 disabled:cursor-not-allowed"
                  :disabled="isSubmitting"
                >
                  <!--<span v-if="isSubmitting">Creando...</span>-->
                  <span>Crear Cuenta</span>
                </button>
              </div>

              <!-- Link para iniciar sesión si ya tiene cuenta -->
              <div class="flex flex-col md:flex-row items-center text-center md:text-start text-sm font-normal text-custom_black mt-4">
                <span>Si ya tienes una cuenta puedes&nbsp;</span>
                <router-link :to="{ name: 'login' }" class="text-tuin_base-0 text-sm font-semibold not-italic hover:underline">
                  ¡Iniciar Sesión!
                </router-link>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Panel derecho con imagen -->
      <div class="hidden w-1/2 sm:flex items-center justify-center">
        <div>
          <img
            src="@/assets/imgs/undraw_small-town_76a2.svg"
            alt="Tuin hora de hacer magia"
            class="max-h-[353px] max-w-[717px]"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeaderComponent from '@/components/login/HeaderComponent.vue'
import ValidatedPasswordInput from '@/components/ValidatedPasswordInput.vue'
import PasswordInputComponent from '@/components/PasswordInputComponent.vue'
import ToastAlert from '@/commond/ToastAlert.vue'
import { ref, computed } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useStore } from "vuex";
let store = useStore();
const router = useRouter()

// Estado formulario
const email = ref('')
const password = ref('')
const password_confirmation = ref('')
const terms = ref(false)

// Estado de errores
const errors = ref({
  email: '',
  password: '',
  password_confirmation: ''
})

// Estado de pasos
const currentStep = ref(0)
const progressPercentage = computed(() => ((currentStep.value + 1) / 4) * 100)

// Estado para alertas
const toastAlert = ref(false)
const typeMsg = ref('')
const msg = ref('')
const tittle = ref('')

// Estado para evitar envío múltiple
const isSubmitting = ref(false)

// Funciones de validación
function validateEmail() {
  errors.value.email = ''
  
  if (!email.value) {
    errors.value.email = 'Campo obligatorio'
    return false
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email.value)) {
    errors.value.email = 'El correo no es válido'
    return false
  }
  
  return true
}

function validatePassword() {
  errors.value.password = ''
  
  if (!password.value) {
    errors.value.password = 'Campo obligatorio'
    return false
  }
  
  return true
}

function validatePasswordConfirmation() {
  errors.value.password_confirmation = ''
  
  if (!password_confirmation.value) {
    errors.value.password_confirmation = 'Campo obligatorio'
    return false
  }
  
  if (password_confirmation.value !== password.value) {
    errors.value.password_confirmation = 'La contraseña no es la misma'
    return false
  }
  
  return true
}

function validateForm() {
  // Ejecutar todas las validaciones para asegurar que se muestren todos los errores
  const isEmailValid = validateEmail()
  const isPasswordValid = validatePassword()
  const isPasswordConfirmationValid = validatePasswordConfirmation()
  
  return isEmailValid && isPasswordValid && isPasswordConfirmationValid
}

// Lógica del registro
async function RegisterAccount() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  // Validar todos los campos y mostrar errores
  if (!validateForm()) {
    isSubmitting.value = false;
    return
  }
  
  if (!terms.value) {
    toastAlert.value = true
    typeMsg.value = 'danger'
    msg.value = 'Debes aceptar los términos y condiciones'
    tittle.value = 'Error'
    setTimeout(() => closeToast(), 5000)
    isSubmitting.value = false;
    return
  }

  let params = {
    email: email.value,
    password: password.value,
    type_account: 3,
    source:"asesores",
  }

  try {
    // Crear cuenta
    const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/create_account`, params)

    if (response.status === 200) {
      // Si la cuenta se crea, inicia sesión automáticamente
      await axios.post(`${process.env.VUE_APP_API_BASE_URL}/login`, {
        email: email.value,
        password: password.value,
      }).then(function (loginResponse) {
        // Guardar sesión en el store
        store.dispatch("saveUserSession", loginResponse.data.resp);

        // Mostrar toast y redirigir a la ruta 'step1'
        toastAlert.value = true
        typeMsg.value = 'success'
        msg.value = 'Cuenta creada e inicio de sesión exitoso'
        tittle.value = 'Exito'

        setTimeout(() => {
          closeToast()
          router.push({ name: 'step1' }) // Redirige a la ruta 'step1'
        }, 2000)
      })
    }
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response

      if (status === 422) {
        for (const field in data.errors) {
          data.errors[field].forEach((message) => {
            toastAlert.value = true
            typeMsg.value = 'danger'
            msg.value = message
            setTimeout(() => closeToast(), 5000)
          })
        }
      } else {
        toastAlert.value = true
        typeMsg.value = 'danger'
        msg.value = `Error ${status}: ${data.message || 'Ocurrió un error inesperado'}`
        setTimeout(() => closeToast(), 5000)
      }
    } else {
      toastAlert.value = true
      typeMsg.value = 'danger'
      msg.value = 'Error inesperado, intenta de nuevo.'
      setTimeout(() => closeToast(), 5000)
    }
  }
  isSubmitting.value = false;
}

function closeToast() {
  toastAlert.value = false
  typeMsg.value = ''
  msg.value = ''
  tittle.value = '';
}

const termsLink = computed(() => {
  const host = window.location.host;
  if (host === 'asesores.tuin.ai') {
    return 'https://tuin.ai/legal/terminos-y-condiciones';
  } else {
    return 'https://qa.tuin.ai/legal/terminos-y-condiciones';
  }
});
</script>

<style scoped>
::v-deep .custom-label label {
  color: white;
}

::v-deep .custom-input {
  background-color: transparent;
}
</style>
